import { ActionTypes } from "./actions";
import { defaultState, bindReducers } from "src/utils/genState";
import createReducer from "src/utils/reduxsauce/createReducer";

const initialState = {
  ...defaultState("settings", { metadata: undefined }, []),
};

const settingEditedSuccess = (state, draft, payload) => {
  const settings = state.settings || [];
  var settingIndex = settings.findIndex((u) => u.id === payload.id);
  draft.settings[settingIndex] = payload;
};

const editSettingSuccess = (state, draft, payload) => {
  const index = state.settings.findIndex((r) => r.id === payload.id);
  if (index >= 0) {
    draft.settings[index] = payload;
  }
  draft.openDialog = false;
};

const showDialog = (state, draft, payload) => {
  draft.openDialog = true;
};
const showDeleteDialog = (state, draft, payload) => {
  draft.openDeleteDialog = true;
};
const resetDialog = (state, draft, payload) => {
  draft.openDialog = false;
  draft.openDeleteDialog = false;
};

export const reducer = createReducer(initialState, {
  ...bindReducers(ActionTypes, {
    action: "getSettings",
    stateName: "settings",
    async: true,
    isPaginated: true,
  }),
  ...bindReducers(ActionTypes, {
    action: "editSetting",
    stateName: "setting",
    async: true,
    isPaginated: false,
    successCb: editSettingSuccess,
  }),
  ...bindReducers(ActionTypes, {
    action: "editAllSettings",
    stateName: "settings",
    async: true,
    isPaginated: false,
    // successCb: settingEditedSuccess,
  }),
  ...bindReducers(ActionTypes, {
    action: "showDeleteDialog",
    stateName: "showDeleteDialog",
    async: false,
    isPaginated: false,
    successCb: showDeleteDialog,
  }),

  ...bindReducers(ActionTypes, {
    action: "showDialog",
    stateName: "showDialog",
    async: false,
    isPaginated: false,
    successCb: showDialog,
  }),
  ...bindReducers(ActionTypes, {
    action: "resetDialog",
    stateName: "resetDialog",
    async: false,
    isPaginated: false,
    successCb: resetDialog,
  }),
});
